// extracted by mini-css-extract-plugin
export default {"wrapperButtonStep":"button-submit-step_wrapperButtonStep__MAR-J","gray":"button-submit-step_gray__7Pftq"};